import React from 'react';

import { fireGTMEvent } from 'src/features/analytics/hooks/useGtm';
import { CmsPageQuery } from 'src/components/CmsPage/CmsPageQuery';
import { NostoContextProvider } from 'src/components/Nosto';

import '../../scss/_root-component.scss';

type CmsPageProps = {
    id: number | null;
};

export function CmsPage(props: CmsPageProps) {
    React.useEffect(() => {
        fireGTMEvent({ event: 'pageview', pageType: 'Content page' });
    }, []);
    return (
        <NostoContextProvider pageType="other">
            <div data-page-test-id="cms-page"></div>
            <CmsPageQuery id={props.id} />
        </NostoContextProvider>
    );
}

export default CmsPage;
